import type { Game } from './game';

/** Count the shelves the player can actually see, including ordinary searchable ones. */
export function libraryClue(g: Game, leverIndex = g.cfg.leverIndex): string {
  const f = g.mansion.get('ground');
  const levers = f.props.filter(p => p.kind.id === 'bookshelfLever').sort((a, b) => a.x - b.x);
  const target = levers[leverIndex];
  const fire = f.props.find(p => p.room === 'library' && p.kind.id === 'fireplace');
  if (!target || !fire) return '[낡은 메모]\n서재의 벽난로 곁 책장에 비밀이 있다.';
  const center = fire.x + fire.kind.fw / 2, left = target.x < center;
  const shelves = f.props.filter(p => p.room === 'library' && p.y === fire.y && p.kind.id.startsWith('bookshelf') && (p.x < center) === left)
    .sort((a, b) => Math.abs(a.x - center) - Math.abs(b.x - center));
  const nth = shelves.indexOf(target) + 1;
  return `[낡은 메모]\n서재의 비밀은 벽난로 ${left ? '왼쪽' : '오른쪽'} ${nth}번째 책장에 있다.\n벽난로와 같은 벽의 책장만 센다.\n함정 책장을 건드리면 책이 쏟아진다. 그 소리는 "그것"을 부른다.`;
}

/** Repair this specific old clue without revealing any unread paper. */
export function repairLibraryClues(g: Game): void {
  const text = libraryClue(g);
  const repair = (entry: { kind: string; text?: string }) => {
    if (entry.kind === 'note' && /^\[낡은 메모\]\n서재의 비밀은 벽난로 (왼쪽|오른쪽) \d+번째 책장에 있다\./.test(entry.text ?? '')) entry.text = text;
  };
  for (const entry of g.journal) repair(entry);
  for (const item of g.items) { repair(item); for (const entry of item.contents ?? []) repair(entry); }
  for (const c of g.chars.values()) for (const item of c.inventory) repair(item);
}
